export default {
  menu: {
    bussinesscooperator: '成為ChrgiePower合作夥伴',
    advertisingplatform: '人才招聘',
    contactUS: '聯繫我們',
    faq: '常見問題',
    serviceIntro: '關於我們',
    usage: '使用方法',
    fee: '收費方式',
    brands: '合作品牌'
    },
      aboutUs: {
    title: '    香港拾壹新啓點科技有限公司--智創共用能源生態，賦能城市活力續航 作為香港共享經濟領域的革新力量，拾壹新啓點科技深耕智能充電解決方案，以「全場景覆蓋+極速充電科技」為核心，構建全港規模最大的便捷共享能源服務網絡。我們通過自主研發的第四代智能共用充電設備，為便利店、商超綜合體、酒店食肆、文旅地標及公共交通樞紐等200+場景提供24小時不間斷的充電支持，日均服務超10萬人次，讓城市永不斷電。公司成立之初，以成為香港最大的共享經濟企業為宏偉目標。為了實現這 一 目標,公司不斷加大投入，提升充電的技術標準、擴大充電的覆蓋範圉、提高用戶與客戶的服務標準。致力於為廣大市民群眾提供便捷、高效、可靠的充電服務，把超大容量與超快充電技術覆蓋全港。公司的口號是“讓生活充滿電”。這不僅體現了公司對産品的期許,也代表了我們對社會的責任。我們相信，科技可以改變生活，讓生活更加美好。公司於2023年入住香港共享充電寶品牌，於2025年初正式推出超大容量、超級快充產品。',
    // intro: '這裡是繁體中文的介紹。'
  },
  bussinesscooperator: {
    // title: '成為ChrgiePower合作夥伴',
    // content: '這裡是最新的成為ChrgiePower合作夥伴。'
      title: '',
    content: ''
  },
  faq: {
    title: '常見問題',
    questions: [
         {
        q: '無法在手機地圖上查看到附近的門店？',
        a: '產生這種情況可能的原因有：用戶手機設備GPS未開啟、系統許可權未開啟、網路狀態不佳、獲取定位資訊超時等。建議您優先檢查系統許可權、網路狀態並嘗試刪除小程式重新進入，在小程式申請定位時選擇“允許訪問定位”，並確認微信、支付寶等應用本身有定位許可權；同時確認用戶所在地是否是商場地下等非開闊地區，如果在室內也可能出現定位失敗的問題。許可權和網路調整好後，請您手動調整定位，縮放地圖，進而找到可歸還點位。',
      },
      {
        q: '借用了移動電源後可以在其他地方還嗎？',
        a: '可在中国香港、中国大陆地區任一有CHRGIE POWER的充電機櫃點位處歸還',
      },
       {
        q: '顯示租借成功，但未彈出移動電源？',
        a: '請留意機櫃左右側彈出的移動電源，如果移動電源未彈出，請聯繫客服人員協助處理。',
      },
        {
        q: '如何租用移動電源？',
        a: '首先，您必須在 App Store 或 Google Play 上下載 xxx 應用程式。您需要創建或登錄 xxx 帳戶，提供有效的手機號碼或電子郵件，並輸入我們發送到該號碼或電子郵件的四位一次性密碼短信。點擊應用程式主螢幕上的 “掃碼租借”，掃描充電機櫃前的二維碼。如果您正在尋找站點，請查看應用程式中的地圖。',
      },
      {
        q: '如果我無法從站點取出一個移動電源，我該怎麼辦？',
        a: '請聯繫應用程式內的支持團隊，客服人員協助處理。',
      },
      {
        q: '如果充電機櫃空了，我該怎麼辦？',
        a: '如果充電機櫃無可租借移動電源，請通過應用程式查找下一個較近的站點。',
      },
      {
        q: '如何歸還移動電源？',
        a: '歸還時，只需將移動電源推入任意充電機櫃的空槽即可。將其完全推入，直到發出哢嗒聲，然後等待應用程式顯示您的租賃記錄，如果沒有，請聯繫應用程式內的支持人員。',
      },
      {
        q: '如果要歸還的充電機櫃已滿，我該怎麼辦？',
        a: '如果充電機櫃已滿，要將移動電源放回充電機櫃，請通過應用程式查找下一個較近的充電機櫃站點。',
      },
      {
        q: '如果充電機櫃沒有彈出移動電源，但運行程式開始運行，我該怎麼辦？',
        a: '首先刷新訂單頁面，檢查訂單是否已結束。如果訂單仍在運行，請選擇正在運行的訂單上的 “客戶服務 ”按鈕，然後按照提示一步步操作。(您需要提交一張清晰的充電櫃正面照片，並清楚標明二維碼）。訂單將結束，您可以重新開始租賃。',
      },
       {
        q: '如果我已經歸還了移動電源，但訂單仍在運行，我該怎麼辦？',
        a: '您首先需要確保歸還的充電機櫃處於通電狀態。其次檢查並確認移動電源已正確插入。刷新訂單頁面，檢查訂單頁面是否停止（網路不佳可能會延遲回應）。如果訂單仍在運行，請點擊主頁上的 “客戶服務 ”按鈕，並按步驟說明操作。(請通過應用程式報告充電機櫃故障，或聯繫應用程式內支持團隊。',
      },
      {
        q: '如何報告充電機櫃故障？',
        a: '請通過應用報告充電機櫃故障，或聯繫應用內支持團隊。',
      },
      {
        q: '如果我租用了移動電源，但沒有數據線，該怎麼辦？',
        a: '如果沒有電源線，請先歸還至充電機櫃，並在應用程式提示內報告。 您將不會為此支付租金。然後請繼續租用另一個移動電源。',
      },
      {
        q: '我的移動電源無法為手機充電，我該怎麼辦？',
        a: '確保數據線正確插入設備。我們建議您取下厚厚的手機殼，讓數據線完全插入。如果仍然無法充電，請將移動電源放回充電機櫃，並通過應用內支持與我們聯繫。',
      },
      {
        q: '如果我丟失/未歸還移動電源，會發生什麼情況？',
        a: '您需要支付違約金。價格計畫顯示在主頁橫幅上。',
      },
      {
        q: '如何檢查移動電源的電量？',
        a:'只需按下電源箱正面的按鈕，LED 指示燈就會顯示電量水準。'
      },
       {
        q: '一個移動電源的租金是多少？',
        a:'一般價格計畫顯示在主頁橫幅上。掃描充電機櫃二維碼後也會顯示價格計畫。'
      },
       {
        q: '如何支付租賃費用？',
        a:'首次登錄後，系統會提示您添加一張有效的信用卡/借記卡。歸還至充電機櫃時，租金將自動從默認卡中扣除。如果付款失敗，再次登錄時主頁上將顯示未付款訂單，您必須手動完成付款才能恢復正常服務。'
      },
       {
        q: '如何查看我的移動電源使用了多長時間以及花費了多少錢？',
        a:'一旦開始租用移動電源，應用程式中就會顯示這些資訊。時間和累積的確切費用都會顯示出來。'
      },
         {
        q: '如果我被多收了費用，我該怎麼辦？',
        a:'請聯繫應用內支持團隊，我們將很樂意為您提供幫助。'
      },
       {
        q: '為什麼我需要使用信用卡/借記卡？',
        a:'您需要使用信用卡/借記卡作為安全保障，以鼓勵公平、安全地使用我們的服務。'
      },
       {
        q: '如何退還押金？',
        a:'1.如移動電源已歸還成功，訂單狀態已更新。2.進入 “錢包頁面”，點擊 “退款 ”按鈕並提交。3.退款將在3-6個工作日返還到您充值時使用的同一銀行帳戶。'
      },
       {
        q: '如果我收到退款，需要多長時間？',
        a:'在退款撤銷的情況下，客戶不會在對帳單上看到退款信用額度--您只會看到原始授權在幾天後從對帳單上完全刪除。沒有付款，也沒有退款。整個交易就好像從未發生過一樣。您的銀行應該可以向他們確認這一點。根據髮卡行的不同，原始費用會在 7 個工作日後從待處理費用中消失。'
      },
        {
        q: '我沒有收到應用程式的驗證碼，我該怎麼辦？',
        a:'這取決於您的手機是否有足夠的移動信號來接收。您可能需要進入信號較好的範圍。否則，請確保您輸入了正確的手機號碼。如果您使用電子郵件，請記得檢查垃圾郵件。如果其他方法都無效，請聯繫應用內支持團隊，我們將幫助您設置帳戶。'
      },
       {
        q: '應用程式無法使用， 我該怎麼辦？',
        a:'您可以先嘗試刷新應用程式。如果還不行，請刪除並重新安裝應用程式。如果還不行，請聯繫支持團隊，我們會幫您解決！'
      },
         {
        q: '如何註銷用戶？',
        a:'打開CHRGIE POWER應用程式，前往「帳戶設定」→ 選擇「註銷」→ 同意「用戶協議」，點擊「確認刪除」，按照提示確認刪除。'
      },
      // 其他问题和答案...
    ]
  }
}
